import { capitalize } from '../utils/capitalize';
import { MONTHS } from '../constants/month';

/**
 * Коллбэк формирует заголовок тултипа, который появляется при наведении на точку графика
 * Из полученного таймштампа должен сформироваться заголовок вида "Mm yyyy"
 * */
export var getTooltipTitleVarA = function getTooltipTitleVarA(tooltipItems) {
  try {
    var date = tooltipItems[0].label;
    var dateObj = new Date(date);
    return "".concat(capitalize(MONTHS[dateObj.getMonth()]), " ").concat(dateObj.getFullYear());
  } catch (e) {
    return '';
  }
};

/**
 * Коллбэк формирует заголовок тултипа, который появляется при наведении на точку графика
 * Из полученного таймштампа должен сформироваться заголовок вида "dd mm yyyy"
 * */
export var getTooltipTitleVarB = function getTooltipTitleVarB(tooltipItems) {
  try {
    var date = tooltipItems[0].label;
    var dateObj = new Date(date);
    return "".concat(dateObj.getDate(), " ").concat(MONTHS[dateObj.getMonth()], " ").concat(dateObj.getFullYear());
  } catch (e) {
    return '';
  }
};